import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core'
import {Observable, Subject} from 'rxjs'
import {tap, takeUntil} from 'rxjs/operators'

@Component({
  selector: 'app-terminal-events-filter',
  templateUrl: './terminal-events-filter.component.html',
  styleUrls: ['./terminal-events-filter.component.scss'],
  standalone: false,
})
export class TerminalEventsFilterComponent implements OnInit, OnDestroy {
  @Input() filters: Observable<any>
  allChecked = false
  @Output() itemChanged = new EventEmitter<{key: string; selected: boolean}>()
  @Output() onSelectAll = new EventEmitter<boolean>()
  private destroy$ = new Subject<void>()

  constructor() {}

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  ngOnInit() {
    this.filters
      .pipe(
        takeUntil(this.destroy$),
        // take(1),
        tap((filters) => {
          const allTrue = filters.every((filter) => filter.selected)
          const allFalse = filters.every((filter) => !filter.selected)
          this.allChecked = allTrue || allFalse
        }),
      )
      .subscribe()
  }

  selectItem(event, item) {
    // Just emit the value the component wants to set (note the toggle in item.selected)
    this.itemChanged.emit({key: item.key, selected: !item.selected})
  }

  toggleSelectAll() {
    // with our logic all means nothing - nothing means all
    this.allChecked = !this.allChecked
    this.onSelectAll.emit(this.allChecked)
  }

  allFilterSelected(filters) {
    return undefined === filters.find((filter) => !filter.selected)
  }
}
